import { render, staticRenderFns } from "./MyTitleApp.vue?vue&type=template&id=05889fbb&scoped=true"
var script = {}
import style0 from "./MyTitleApp.vue?vue&type=style&index=0&id=05889fbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05889fbb",
  null
  
)

export default component.exports